var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GmapMap',{ref:"mapRef",staticClass:"map-container",attrs:{"center":_vm.center,"zoom":_vm.zoom,"options":{
    disableDoubleClickZoom: true
  }},on:{"dblclick":_vm.mark}},[_c('GmapInfoWindow',{attrs:{"options":_vm.infoOptions,"position":_vm.infoWindowPos,"opened":_vm.infoWinOpen},on:{"closeclick":_vm.closeMap}}),_vm._l((_vm.locations),function(key,i){return _c('GmapMarker',{key:i,attrs:{"icon":_vm.reporting
        ? key.building_type == 'Apartment'
          ? {
              url: require('../assets/marker/apartment-purple.png'),
              scaledSize: _vm.sizeIcon
            }
          : key.building_type == 'Hotel'
          ? {
              url: require('../assets/marker/hotel-purple.png'),
              scaledSize: _vm.sizeIcon
            }
          : key.building_type == 'Retail'
          ? {
              url: require('../assets/marker/retail-purple.png'),
              scaledSize: _vm.sizeIcon
            }
          : key.building_type == 'Office'
          ? {
              url: require('../assets/marker/office-purple.png'),
              scaledSize: _vm.sizeIcon
            }
          : {
              url: require('../assets/marker/other-purple.png'),
              scaledSize: _vm.sizeIcon
            }
        : _vm.installation.includes('complete', 'incomplete', 'needrequest')
        ? key.building_type == 'Apartment'
          ? {
              url: require('../assets/marker/apartment-purple.png'),
              scaledSize: _vm.sizeIcon
            }
          : key.building_type == 'Hotel'
          ? {
              url: require('../assets/marker/hotel-purple.png'),
              scaledSize: _vm.sizeIcon
            }
          : key.building_type == 'Retail'
          ? {
              url: require('../assets/marker/retail-purple.png'),
              scaledSize: _vm.sizeIcon
            }
          : key.building_type == 'Office'
          ? {
              url: require('../assets/marker/office-purple.png'),
              scaledSize: _vm.sizeIcon
            }
          : {
              url: require('../assets/marker/other-purple.png'),
              scaledSize: _vm.sizeIcon
            }
        : _vm.installation == 'incomplete' ||
          _vm.installation == 'needrequest' ||
          _vm.installation.includes('incomplete', 'needrequest')
        ? key.building_type == 'Apartment'
          ? {
              url: require('../assets/marker/apartment-yellow.png'),
              scaledSize: _vm.sizeIcon
            }
          : key.building_type == 'Hotel'
          ? {
              url: require('../assets/marker/hotel-yellow.png'),
              scaledSize: _vm.sizeIcon
            }
          : key.building_type == 'Retail'
          ? {
              url: require('../assets/marker/retail-yellow.png'),
              scaledSize: _vm.sizeIcon
            }
          : key.building_type == 'Office'
          ? {
              url: require('../assets/marker/office-yellow.png'),
              scaledSize: _vm.sizeIcon
            }
          : {
              url: require('../assets/marker/other-yellow.png'),
              scaledSize: _vm.sizeIcon
            }
        : (key.screen_installed == null || key.tower_id == null) &&
          (key.fmi == 'Yes' || key.dfi == 'Yes' || key.other == 'Yes') // Competitor
        ? key.building_type == 'Apartment'
          ? {
              url: require('../assets/marker/apartment-red.png'),
              scaledSize: _vm.sizeIcon
            }
          : key.building_type == 'Hotel'
          ? {
              url: require('../assets/marker/hotel-red.png'),
              scaledSize: _vm.sizeIcon
            }
          : key.building_type == 'Retail'
          ? {
              url: require('../assets/marker/retail-red.png'),
              scaledSize: _vm.sizeIcon
            }
          : key.building_type == 'Office'
          ? {
              url: require('../assets/marker/office-red.png'),
              scaledSize: _vm.sizeIcon
            }
          : {
              url: require('../assets/marker/other-red.png'),
              scaledSize: _vm.sizeIcon
            }
        : key.tower_id !== null &&
          key.screen_installed !== null &&
          key.fmi == 'No' &&
          key.dfi == 'No' &&
          key.other == 'No' // TMN
        ? key.building_type == 'Apartment'
          ? {
              url: require('../assets/marker/apartment-purple.png'),
              scaledSize: _vm.sizeIcon
            }
          : key.building_type == 'Hotel'
          ? {
              url: require('../assets/marker/hotel-purple.png'),
              scaledSize: _vm.sizeIcon
            }
          : key.building_type == 'Retail'
          ? {
              url: require('../assets/marker/retail-purple.png'),
              scaledSize: _vm.sizeIcon
            }
          : key.building_type == 'Office'
          ? {
              url: require('../assets/marker/office-purple.png'),
              scaledSize: _vm.sizeIcon
            }
          : {
              url: require('../assets/marker/other-purple.png'),
              scaledSize: _vm.sizeIcon
            }
        : key.tower_id !== null &&
          (key.fmi == 'Yes' || key.dfi == 'Yes' || key.other == 'Yes') // TMN + Competitor
        ? key.building_type == 'Apartment'
          ? {
              url: require('../assets/marker/apartment-blue.png'),
              scaledSize: _vm.sizeIcon
            }
          : key.building_type == 'Hotel'
          ? {
              url: require('../assets/marker/hotel-blue.png'),
              scaledSize: _vm.sizeIcon
            }
          : key.building_type == 'Retail'
          ? {
              url: require('../assets/marker/retail-blue.png'),
              scaledSize: _vm.sizeIcon
            }
          : key.building_type == 'Office'
          ? {
              url: require('../assets/marker/office-blue.png'),
              scaledSize: _vm.sizeIcon
            }
          : {
              url: require('../assets/marker/other-blue.png'),
              scaledSize: _vm.sizeIcon
            }
        : key.tower_id == null &&
          key.fmi == 'No' &&
          key.dfi == 'No' &&
          key.other == 'No' // Opportunity
        ? key.building_type == 'Apartment'
          ? {
              url: require('../assets/marker/apartment-gray.png'),
              scaledSize: _vm.sizeIcon
            }
          : key.building_type == 'Hotel'
          ? {
              url: require('../assets/marker/hotel-gray.png'),
              scaledSize: _vm.sizeIcon
            }
          : key.building_type == 'Retail'
          ? {
              url: require('../assets/marker/retail-gray.png'),
              scaledSize: _vm.sizeIcon
            }
          : key.building_type == 'Office'
          ? {
              url: require('../assets/marker/office-gray.png'),
              scaledSize: _vm.sizeIcon
            }
          : {
              url: require('../assets/marker/other-gray.png'),
              scaledSize: _vm.sizeIcon
            }
        : key.tower_id !== null &&
          key.screen_installed == null &&
          key.screen_installed == null &&
          key.fmi == 'No' &&
          key.dfi == 'No' &&
          key.other == 'No' // TMN ( Belum di install)
        ? key.building_type == 'Apartment'
          ? {
              url: require('../assets/marker/apartment-yellow.png'),
              scaledSize: _vm.sizeIcon
            }
          : key.building_type == 'Hotel'
          ? {
              url: require('../assets/marker/hotel-yellow.png'),
              scaledSize: _vm.sizeIcon
            }
          : key.building_type == 'Retail'
          ? {
              url: require('../assets/marker/retail-yellow.png'),
              scaledSize: _vm.sizeIcon
            }
          : key.building_type == 'Office'
          ? {
              url: require('../assets/marker/office-yellow.png'),
              scaledSize: _vm.sizeIcon
            }
          : {
              url: require('../assets/marker/other-yellow.png'),
              scaledSize: _vm.sizeIcon
            }
        : 'not valid',"position":key.coordinates,"clickable":true},on:{"click":function($event){return _vm.toggleInfoWindow(key, i, '')}}})}),(!_vm.showMultipleMark)?_c('GmapCircle',{attrs:{"center":_vm.center,"radius":_vm.radius,"visible":true,"options":{
      fillColor: 'red',
      fillOpacity: 0.2,
      strokeWeight: 1,
      strokeOpacity: 1,
      strokeColor: 'red'
    }}}):_vm._e(),(!_vm.showMultipleMark)?_c('GmapMarker',{attrs:{"icon":_vm.generateMarker('#ffe34c'),"position":_vm.center,"clickable":false,"draggable":false}}):_vm._e(),_vm._l((_vm.multipleMarkData),function(item,index){return _c('div',{key:(index + "-multi")},[_c('GmapMarker',{attrs:{"position":item.center,"icon":item.icon,"draggable":false},on:{"click":function($event){return _vm.seeDetailPlaces(item.id)}}}),_c('GmapCircle',{attrs:{"center":item.center,"radius":_vm.radius,"visible":true,"options":{
        fillColor: 'red',
        fillOpacity: 0.2,
        strokeWeight: 1,
        strokeOpacity: 1,
        strokeColor: 'red'
      }}})],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }